import {
  CampaignChannel,
  CampaignSortKey,
  CampaignStatus,
  campaignWithOutreachAnalyticsSchema,
} from "@redotech/redo-model/campaigns/campaign-definition";
import { SortDirection } from "@redotech/redo-model/tables/table";
import * as z from "zod/v4";

export const getTeamCampaigns = {
  name: "getTeamCampaigns" as const,
  input: z.object({
    includeStats: z.boolean().optional(),
    searchString: z.string().optional(),
    filters: z
      .object({
        channel: z.array(z.enum(CampaignChannel)).optional(),
        status: z.array(z.enum(CampaignStatus)).optional(),
        dateRange: z
          .object({
            startDate: z.string().optional(),
            endDate: z.string().optional(),
          })
          .optional(),
      })
      .optional(),
    sort: z
      .object({
        key: z.enum(CampaignSortKey),
        direction: z.enum(SortDirection),
      })
      .optional(),
    page: z.optional(z.number().positive().int()),
    pageSize: z.optional(z.number().positive().int()),
  }),
  output: z.object({
    campaigns: z.array(campaignWithOutreachAnalyticsSchema),
    totalCount: z.number().int(),
  }),
};
